import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  Box,
  IconButton,
  DialogContent,
  Grid,
  Switch,
  FormControlLabel,
  DialogActions,
  Button,
  Stack,
  Alert,
  TextareaAutosize

} from '@mui/material';
import DatePicker from "react-datepicker";
// import required css from library
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from 'prop-types';
import './OKRs.css';
import Select from 'react-select';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Close } from '@mui/icons-material';
import { axiosFetch } from '../../../utils/AxiosFetch';
import { useNavigate } from 'react-router';
import { CustomizedSnackbar } from '../../../shared/index';
import { useDispatch } from "react-redux";
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import moment from "moment";
import SearchKeyResults from "./SearchKeyResultsPopup";
import Dropzone, { useDropzone } from "react-dropzone";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { configAxios } from "../../../utils/ConfigAxios";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  // ValidatorForm.addValidationRule("")
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

let objectiveTitle = "";
const AddNewOkr = (props) => {

  ValidatorForm.addValidationRule('isValid', (value) => {
    var titleRegx = "^[A-Za-z 0-9][^\\'-_]*(\\'[^\\']*)*[A-Za-z0-9!?,_:'@./#&+() |-]*$"

    if (value.match(titleRegx)) {
      return true;
    }
    return false;

  })

  ValidatorForm.addValidationRule('isEmpty', (value) => {
    if (value.trim().length === 0) {
      return false;
    }
    return true;
  }
  )

  const dispatch = useDispatch();
  const navigate = useNavigate();






  const [open, setOpen] = React.useState(props && props.open);
  const [startDate, setStartDate] = React.useState("");
  // const [endDate, setEndDate] = React.useState();
  const [selectedOwner, setSelectedOwner] = React.useState([]);
  const [selectedParticipants, setSelectedParticipants] = React.useState([]);

  const [titleErrMsg, setTitleErrMsg] = useState(false);

  const [isPrivate, setIsPrivate] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [status, setStatus] = useState(null);
  const [url, setURL] = useState("");

  const [isOwnersEmpty, setIsOwnersEmpty] = React.useState(false);

  const [userList, setUserList] = useState([]);
  const [krUserList, setKRUserList] = useState([]);
  const [isKR, setIsKR] = useState(props && props.isAssignKR);
  const [selectedOkrId, setSelectedOkrId] = useState(props && props.selectedOkrId);
  const [objTitle, setObjTitle] = useState(props && props.objectiveTitle);
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isError, setIsError] = useState(false);
  const [ownerErrMsg, setOwnerErrMsg] = useState(false);
  const [disableTitle, setDisableTitle] = useState(false);
  const [KeyResultId, setKeyResultId] = useState(null);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [isValidUrl, setIsValidUrl] = useState(false);
  const [filePhysicalName, setFilePhysicalName] = useState("");
  const [fileActualName, setFileActualName] = useState("");
  const [fileUploadedDate, setFileUploadedDate] = useState("");

  const uploadFilePopup = () => {
    setOpenFileUpload(!openFileUpload);
  }

  const handleChangeURL = (e) => {
    setURL(e.target.value);
  }

  const handleChangeChosenKR = (obj) => {
    setDisableTitle(true);
    setTitle(obj.title);
    // setSelectedOkrId(obj.id);
    setKeyResultId(obj.id);
  }

  const allowedTypes = ["image/jpeg", " image/jpg", " image/png", " image/svg"];

  const renderAcceptedFileTypes = () => {
    let typesStr = "";
    if (allowedTypes) {
      allowedTypes.forEach((type /*, index*/) => {
        typesStr += `${type}, `;
      });
    }

    return typesStr;
  };

  const keyResultsUserList = () => {
    axiosFetch({
      url: `/Lookup/users/${selectedOkrId}`,
      method: "get"
    })
      .then((res) => {
        if (res.status === 200) {
          setKRUserList(res.data);
        }
        // if (res.status === 400) {
        //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        // }
        else if (res.status === 401) {
          navigate('/');
        }
      })

      .catch(err => console.log(err));
  }

  const loadUserList = () => {
    axiosFetch({
      url: "/lookup/users",
      method: "get"
    })
      .then((res) => {
        if (res.status === 200) {
          setUserList(res.data);
        }
        // if (res.status === 400) {

        //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        // }
        else if (res.status === 401) {
          navigate('/');
        }
      })

      .catch(err => console.error(err));
  }


  const saveAsDraft = () => {
    if (title === "") {
      setTitleErrMsg(true);
      return false;
    }
    if (selectedOwner.length === 0) {
      setOwnerErrMsg(true);
      return false;
    }
    if (title !== "") {
      let selectedParticipantsId,
        selectedOwnersId;


      if (selectedParticipants.length !== 0) {
        selectedParticipantsId = selectedParticipants.map((options) => options.value).toString();
      }

      if (selectedOwner.length !== 0) {
        selectedOwnersId = selectedOwner.map((options) => options.value).toString();
      }

      var req = {
        "title": title,
        "description": description,
        "dueDate": startDate !== "" ? moment(startDate).format('YYYY-MM-DD') : null,
        // "completionDate": endDate,
        "statusId": status?.value,
        "completionPercentage": null,
        "assignedUserId": selectedOwner.length !== 0 ? selectedOwnersId : null,
        "participantIds": selectedParticipants.length !== 0 ? selectedParticipantsId : null,
        "assignmentTypeId": isKR ? 2 : 1,
        "isArchived": false,
        "isPublished": false,
        "KeyResultId": KeyResultId !== null ? KeyResultId : null,
        "objectiveId": selectedOkrId !== null ? selectedOkrId : null,
        "IsPrivate": isPrivate

      }

      axiosFetch({
        method: "post",
        url: "/okrs/new",
        requestConfig: req
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              dispatch(SnackbarActions(true, "success", "Saved As Draft!"));
              navigate(`/viewokr/${res.data.oKrId}`);
              props.toggleOkrPopup(false);
              // setTimeout(() => {
              //   props.loadAll_OKRs();
              // }, 3000);

            }
          }
          if (res.status === 400) {
            props.toggleOkrPopup(false);
            dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
          }
          else if (res.status === 401) {
            navigate("/");
          }
        })
      // dispatch(add_Okr(req));
      // if (draftStatus === 'success' && isDraftFailed === "") {

      // dispatch(SnackbarActions(true, "success", "Moved to Draft!"));
      // props.loadAll_OKRs();
      // setTimeout(()=>{
      // props.toggleOkrPopup(false);
      // },1000)



      // }
    }
  }




  const handleSubmit = (param) => {

    setIsSubmit(true);
    setIsError(false);
    setDisableTitle(false);

    let selectedParticipantsId,
      selectedOwnersId;

    if (!isKR && selectedOwner.length === 0) {
      setOwnerErrMsg(true);
      setIsSubmit(false);
      return false;
    }
    if (selectedOwner.length !== 0) {
      selectedOwnersId = selectedOwner.map((owner) => owner.value).toString();
    }

    if (selectedParticipants.length !== 0) {
      selectedParticipantsId = selectedParticipants.map((participant) => participant.value).toString();
    }


    objectiveTitle = title;
    var req = {
      // "id" : 0,
      "title": title ? title : null,
      "description": description ? description : null,
      "dueDate": startDate !== "" ? moment(startDate).format('YYYY-MM-DD') : null,
      // "completionDate": endDate ? endDate  : null,
      "statusId": status ? status.value : null,
      "completionPercentage": null,
      "assignedUserId": selectedOwner.length !== 0 ? selectedOwnersId : null,
      "participantIds": selectedParticipants.length !== 0 ? selectedParticipantsId : null,
      "departmentId": null,
      "assignmentTypeId": isKR ? 2 : 1,
      "isArchived": false,
      "isPublished": true,
      "objectiveId": selectedOkrId !== null ? selectedOkrId : null,
      "IsPrivate": isPrivate,
      "KeyResultId": KeyResultId !== null ? KeyResultId : null,
    }


    axiosFetch({
      method: "post",
      url: "/okrs/new",
      requestConfig: req
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data) {

            props.toggleOkrPopup(false);

            if (isKR && param !== undefined && typeof (param) !== 'number') {
              dispatch(SnackbarActions(true, "success", "New KR Created!"));
              navigate(`/viewokr/${selectedOkrId}`);
            }
            else if (!isKR && param !== undefined && typeof (param) !== 'number') {
              dispatch(SnackbarActions(true, "success", "New OKR Created!"));
              navigate(`/viewokr/${res.data.oKrId}`);
            }

            props.handlePageChange(1);

            setTimeout(() => {

              // if (isKR && param !== undefined && typeof (param) !== 'number') {
              //   navigate(`/viewokr/${selectedOkrId}`);
              // }
              // else if (!isKR && param !== undefined && typeof (param) !== 'number') {
              //   navigate(`/viewokr/${res.data.okrId}`);
              // }

              if (param === 1) {
                props.toggleOkrPopup("1", { okrId: res.data.oKrId, okrTitle: objectiveTitle });
              }
              // else {
              //   props.toggleOkrPopup(false);
              // }

              if (props.callFrom === 1) {
                props.loadKeyResults();
              }
              else if (props.callFrom === 0) {
                props.loadAll_OKRs();
              }

              // window.location.reload();
            }, 2000);


          }
        }
        if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })
      .catch(err => console.error(err));
    // dispatch(add_Okr(req));

  }

  const handleChangeOwner = (selected) => {
    ;
    let filteredArr = selectedParticipants.filter(el => selected.find(obj => obj.value === el.value));
    if (selected.length !== 0) {

      if (selectedParticipants.length !== 0) {
        if (selected.length !== 0) {
          if (filteredArr.length !== 0) {
            setIsOwnersEmpty(true);
            setOwnerErrMsg(false);
            return false;
          }
          else {
            setSelectedOwner(selected);
            setIsOwnersEmpty(false);
          }
        }
      } else {
        setSelectedOwner(selected);
        setOwnerErrMsg(false);
        setIsOwnersEmpty(false);
      }

    }
    else if (!isKR && selected.length === 0) {
      setSelectedOwner(selected);
      setOwnerErrMsg(true);
      setIsOwnersEmpty(false);
    }
    else if (isKR) {
      setSelectedOwner(selected);
    }
  }
  const handleChangeParticipants = (selected) => {
    ;
    let filteredArr = selectedOwner.filter(el => selected.find(obj => obj.value === el.value));
    if (selectedOwner.length !== 0) {
      if (selected.length !== 0) {
        if (filteredArr.length !== 0) {
          setIsError(true);
          return false;
        }

      }

      else {
        setSelectedParticipants(selected);
        setIsError(false);
      }
    }

    setSelectedParticipants(selected);
    setIsError(false);

  }




  const uploadImage = (file) => {

    if (file && file[0]) {
      const formData = new FormData();
      formData.append("file", file[0], file[0].name);
      console.log(formData);
      uploadFile(formData);
    }
  };

  const uploadFile = (file) => {
    configAxios
      .post("/Uploads/file", file)
      .then((res) => {
        if (res.status === 200) {
          setFileActualName(res.data.actualFileName);
          setFilePhysicalName(res.data.physicalFileName);
          setFileUploadedDate(res.data.uploadedDate);
        }
        else if (res.status === 401) {
          navigate("/");
        }
        else if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
      })
      .catch(err => {

      })
  }

  const uploadOKRAttachments = (e) => {

    e.preventDefault();

    var isValid = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(url)
    console.log(isValid);
    if (isValid) {
      setIsValidUrl(false);
      axiosFetch({
        url: "/okr/Attachments",
        method: "POST",
        requestConfig: {

        }

      })
    }
    else {
      setIsValidUrl(true);
    }

    // console.log(file);
  }

  const clearAll = () => { }

  const toggleKrPopup = (param) => {
    if (param === undefined) {
      setIsOpen(true);
    }
    else {
      setIsOpen(param);
    }

  }
  const handleChangeTitle = (e) => {
    setTitle(e.target.value);
    setTitleErrMsg(false);
  }
  const addKRAlong = () => {
    if (title === "") {
      setTitleErrMsg(true);
      return false;
    }
    if (selectedOwner.length === 0) {
      setOwnerErrMsg(true);
      return false;
    } if (title !== "" && selectedOwner.length !== 0) {
      handleSubmit(1);
    }
  }





  useEffect(() => {
    loadUserList();
    keyResultsUserList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (

    <React.Fragment>
      {isOpen ?
        (
          <SearchKeyResults
            open={isOpen}
            toggleKrPopup={toggleKrPopup}
            handleChangeChosenKR={handleChangeChosenKR}
          />
        ) : ""}
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={openFileUpload}
        fullWidth="sm"
        maxWidth="sm"
        onClose={uploadFilePopup}
      >
        <ValidatorForm >
          <BootstrapDialogTitle>
            Upload OKR Attachments
          </BootstrapDialogTitle>
          <DialogContent>
            <Box
              alignItems="center"
              display="flex"
              justifyContent="center"
              component="form"
              autoComplete="off"
            >
              <Grid container xs={12}>
                <Grid item xs={12}>
                  <Dropzone
                    disableClick={true}
                    onDrop={(e) => uploadImage(e)}
                    className="dropzone"
                    activeClassName="active-dropzone"
                    multiple={false}
                  // accept={renderAcceptedFileTypes}
                  >
                    {({ getRootProps, getInputProps, acceptedFiles }) => (
                      <section>
                        <div
                          {...getRootProps()}
                          style={{
                            cursor: "pointer",
                            border: "1px solid black",
                          }}
                        >
                          <input {...getInputProps()} />
                          <p>
                            <UploadFileIcon /> Click here to Upload File
                          </p>
                        </div>
                        <ul className="list-group mt-2">
                          {acceptedFiles.length > 0 && acceptedFiles.map(acceptedFile => (
                            <li className="list-group-item list-group-item-success">
                              {acceptedFile.name}
                            </li>
                          ))}
                        </ul>
                      </section>

                    )}
                  </Dropzone>

                </Grid>
                <Grid item xs={12}>
                  <p>(or)</p>

                  <TextValidator
                    variant="outlined"
                    label="Enter File Url"
                    value={url}
                    onChange={handleChangeURL}
                  />
                  <p>{isValidUrl ? "Please Enter Valid Url" : ""}</p>
                </Grid>
                <Grid item xs={12}>
                  <Button variant="contained" onClick={clearAll}>Clear</Button>
                  <Button variant="contained" onClick={uploadOKRAttachments}>Upload File</Button>
                </Grid>
              </Grid>

            </Box>
          </DialogContent>
        </ValidatorForm>

      </BootstrapDialog>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth="sm"
        maxWidth="sm"
        onClose={() => props.toggleOkrPopup(false)}
      >

        <ValidatorForm
          onSubmit={handleSubmit}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => props.toggleOkrPopup(false)}
            className="modal-heading"
          >
            {isKR ? "Create a new Key Result" : "Create a new Objective"}
          </BootstrapDialogTitle>

          <DialogContent dividers>
            <Stack sx={{ width: '100%', marginBottom: "15px" }} spacing={2}>{isKR ? (<Alert severity="warning">Key Results are measurable outcomes, which means they should have a number in them. With Key Results you define what the success of your Objective looks like. Do not list tasks or projects, those are outputs and not measurable outcomes! Instead think about WHY you are doing things and what kind of results you want.</Alert>) :
              (<Alert severity="warning">Objectives should provide business value and should be achievable. Think of the areas that need improvements in order to have better results.</Alert>)}</Stack>
            {/* <p className="okr-para">
              <EmojiObjectsOutlined />
            </p> */}
            <Box
              alignItems="center"
              display="flex"
              justifyContent="center"
              component="form"
              autoComplete="off"
            >
              <Grid container spacing={2} xs={12} className="grid-margins">
                {isKR ? <Grid item xs={12} className="grid-margins">
                  <strong>Objective : {objTitle}</strong>
                  {/* <TextValidator
                    id="input-with-icon-textfield"
                    variant="outlined"
                    fullWidth
                    label="Objective Title"
                    value={objTitle}
                    disabled={true}
                  /> */}
                </Grid> : ""}
                <Grid item xs={12} className="grid-margins">
                  <TextValidator
                    id="input-with-icon-textfield"
                    variant="outlined"
                    fullWidth
                    label="Title"
                    value={title}
                    onChange={(e) => handleChangeTitle(e)}
                    disabled={disableTitle}
                    validators={["required", "isEmpty"]}
                    errorMessages={["Please fill out this field", "Please enter valid Title", "Please enter valid Title"]}
                  />
                  {titleErrMsg ? (<span>Please fill out this field</span>) : ""}
                  {isKR ? "" : <><center style={{ margin: "10px 0" }}>(or)</center>
                    <Button variant="text" style={{ float: "unset", width: "100%" }} className="theme-btn" onClick={() => toggleKrPopup()}>Select an existing Key Result as an Objective</Button></>}
                </Grid>

                <Grid item xs={6} className="grid-margins">
                  <DatePicker
                    // minDate={moment().toDate()}
                    placeholderText="Due Date"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    dateFormat="dd-MM-yyyy"
                    className="datetime"
                  />
                  {/* <TextValidator
                    onFocus={onFocus_DueDate}
                    onBlur={onBlur_DueDate}
                    label="Due Date"
                    type={hasValue_DueDate || focus_DueDate ? "date" : "text"}
                    variant="outlined"
                    fullWidth
                    value={startDate}
                    onChange={(e) => {
                      if (e.target.value) {
                        setHasValue_DueDate(true);
                        setStartDate(e.target.value);
                      }
                      else {
                        setHasValue_DueDate(false);
                      }

                    }}
                  /> */}
                </Grid>
                {isKR || disableTitle ? null : <Grid item xs={6} className="grid-margins" sx={{ paddingTop: "15px !important", textAlign: "center" }}>
                  <FormControlLabel
                    control={
                      <Switch
                        name="isPrivate"
                        color="primary"
                        checked={isPrivate}
                        className="theme-switch"
                        onChange={(e) => setIsPrivate(e.target.checked)}
                      />
                    }
                    label="Make this Private"
                  />
                </Grid>}
                <Grid item xs={12} className="grid-margins description-custom-popup">
                  <TextareaAutosize
                    id="input-with-icon-textfield"
                    variant="outlined"
                    fullWidth
                    placeholder="Description"
                    className="desc-okr"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Grid>
                {/* <Grid item xs={12} className="grid-margins description-custom-popup">
                  <Button variant="contained" className="theme-btn" style={{ float: "unset", width: "100%" }} onClick={uploadFilePopup}>Upload File</Button>
                </Grid> */}
                <Grid item xs={6} className="grid-margins">
                  {/* <h3>Select Owner</h3> */}
                  <Select menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={isKR ? krUserList : userList} value={selectedOwner} onChange={handleChangeOwner} placeholder="Select Owner" isMulti={true} />
                  <p className="required-msg">{ownerErrMsg ? "Please fill out this field" : ""}</p>
                  <p className="required-msg">{isOwnersEmpty ? "Owner & Participant can't be same person" : ""}</p>
                </Grid>
                <Grid item xs={6} className="grid-margins">
                  <Select menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={isKR ? krUserList : userList} value={selectedParticipants} onChange={handleChangeParticipants} placeholder="Select Participants" isMulti={true} />
                  <p className="required-msg">{isError ? "Owner & Participant can't be same person" : ""}</p>
                </Grid>
                {/* <Grid item xs={12}>
                  <Select options={departmentList} placeholder="Select Department" value={selectedDept} onChange={setSelectedDept} isMulti={true} />
                </Grid> */}

              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              className="theme-btn danger-btn"
              onClick={() => props.toggleOkrPopup(false)}
            >
              Cancel
            </Button>
            &nbsp;
            {isKR || disableTitle ? null : <Button
              variant="contained"
              className="theme-btn cancel-btn"
              onClick={saveAsDraft}
              disabled={isSubmit}
            >
              Save as Draft
            </Button>}
            <Button variant="contained" className="theme-btn" type="submit" disabled={isSubmit}>
              Submit
            </Button>
            {isKR ? "" : <Button variant="contained" className="theme-btn" onClick={addKRAlong} disabled={isSubmit}>
              Save and Add KR
            </Button>}
          </DialogActions>
        </ValidatorForm>
      </BootstrapDialog>
      <CustomizedSnackbar />
    </React.Fragment >

  );
};




export default AddNewOkr;
